export default "__VITE_ASSET__BRC9ZqYE__"